import { render, staticRenderFns } from "./ProductionWorkflowAssessment.vue?vue&type=template&id=23b77a78&scoped=true&"
import script from "./ProductionWorkflowAssessment.vue?vue&type=script&lang=js&"
export * from "./ProductionWorkflowAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b77a78",
  null
  
)

export default component.exports